import React from 'react';
import { Provider, Store } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { history } from '../../utils/router';
import { Persistor } from 'redux-persist';
import { PersistGate } from 'redux-persist/es/integration/react';

import App from './App';

const Root = ({ store, persistor }: { store: Store, persistor: Persistor }) => (
  <PersistGate persistor={persistor}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Route path="" component={App} />
      </ConnectedRouter>
    </Provider>
  </PersistGate>
);

export default Root;



// WEBPACK FOOTER //
// ./src/modules/core/Root.js